(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dorlotte-offre"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dorlotte-offre-choix')) {
    customElements.define('dorlotte-offre-choix', class extends HTMLElement {
      connectedCallback() {
        this.page = this.closest('.dorlotte-page');
        this.form = this.closest('form');
        if (!this.page || !this.form || this.onSelection) return;
        this.onSelection = () => this.sync();
        this.addEventListener('change', this.onSelection);
        window.addEventListener('pageshow', this.onSelection);
        this.sync();
      }
      disconnectedCallback() {
        this.removeEventListener('change', this.onSelection);
        window.removeEventListener('pageshow', this.onSelection);
        this.onSelection = null;
      }
      sync() {
        const choix = this.querySelector('input:checked');
        if (!choix) return;
        const total = choix.dataset.total;
        const quantite = choix.dataset.quantityLabel;
        this.page.querySelectorAll('[data-bundle-total]').forEach((n) => { n.textContent = total; });
        this.page.querySelectorAll('[data-bundle-quantity]').forEach((n) => { n.textContent = quantite; });
        const label = this.form.querySelector('[data-bundle-add-label]');
        if (label && !choix.disabled) label.textContent = `${this.dataset.addLabel} · ${total}`;
        this.page.querySelectorAll('[data-add]').forEach((b) => b.setAttribute('aria-label', `${this.dataset.addLabel} : ${quantite}, ${total}`));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
